import { onError } from '@apollo/client/link/error'

export const errorEvents = new EventTarget()

export class ErrorEvent extends Event {
  public constructor(public readonly message: string) {
    super('error')
  }
}

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) =>
      errorEvents.dispatchEvent(new ErrorEvent(message)),
    )
  }

  if (networkError) {
    errorEvents.dispatchEvent(new ErrorEvent(networkError.message))
  }
})
